import { CategoryQuestions } from '../types';

export const mensEmpowermentQuestions: CategoryQuestions = {
  title: 'Personalize Your Empowerment Session',
  questions: {
    primaryFocus: {
      label: 'What area of empowerment do you want to focus on today?',
      type: 'radio',
      options: [
        'Emotional expression and vulnerability',
        'Managing work stress and provider pressure',
        'Building healthy relationships and intimacy',
        'Mental health and depression/anxiety',
        'Setting boundaries and saying no',
        'Fatherhood and present parenting',
        'Other'
      ]
    },
    primaryFocusOther: {
      label: 'Please specify your focus area',
      type: 'text',
      placeholder: 'Describe what you want to focus on...',
      conditional: {
        field: 'primaryFocus',
        value: 'Other'
      }
    },
    currentChallenges: {
      label: 'What challenges are you facing right now? (Optional)',
      type: 'textarea',
      placeholder: 'Share what you\'re dealing with - this helps personalize your session...'
    },
    emotionalPatterns: {
      label: 'What emotional pattern would you like to shift?',
      type: 'radio',
      options: [
        'Suppressing emotions and "toughing it out"',
        'Anger or irritability masking deeper feelings',
        'Isolation and not asking for help',
        'Performance anxiety and pressure to succeed',
        'Difficulty being vulnerable or opening up',
        'Carrying everything alone without support',
        'Other'
      ]
    },
    emotionalPatternsOther: {
      label: 'Please specify the emotional pattern',
      type: 'text',
      placeholder: 'Describe the pattern you want to shift...',
      conditional: {
        field: 'emotionalPatterns',
        value: 'Other'
      }
    },
    empowermentGoal: {
      label: 'What do you want to strengthen today?',
      type: 'radio',
      options: [
        'Emotional vocabulary and expression',
        'Asking for help and accepting support',
        'Authentic masculinity - strong AND emotionally available',
        'Work-life boundaries and balance',
        'Confidence without dominance',
        'Purpose beyond achievement and productivity',
        'Other'
      ]
    },
    empowermentGoalOther: {
      label: 'Please specify what you want to strengthen',
      type: 'text',
      placeholder: 'Describe your empowerment goal...',
      conditional: {
        field: 'empowermentGoal',
        value: 'Other'
      }
    },
    emotionalTone: {
      label: 'What approach works best for you?',
      type: 'radio',
      options: [
        'Direct and honest - no BS, just truth',
        'Validating - acknowledging the pressure you face',
        'Motivational - calling out your strength',
        'Grounding - creating space to breathe',
        'Empowering - redefining strength to include emotions',
        'Other'
      ]
    },
    emotionalToneOther: {
      label: 'Please specify your preferred approach',
      type: 'text',
      placeholder: 'Describe the approach that works best for you...',
      conditional: {
        field: 'emotionalTone',
        value: 'Other'
      }
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for you?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  practitionerTitle: 'Personalize Empowerment Session for Your Client',
  practitionerQuestions: {
    primaryFocus: {
      label: 'What area of empowerment does your client want to focus on?',
      type: 'radio',
      options: [
        'Emotional expression and vulnerability',
        'Managing work stress and provider pressure',
        'Building healthy relationships and intimacy',
        'Mental health and depression/anxiety',
        'Setting boundaries and saying no',
        'Fatherhood and present parenting',
        'Other'
      ]
    },
    primaryFocusOther: {
      label: 'Please specify your client\'s focus area',
      type: 'text',
      placeholder: 'Describe what your client wants to focus on...',
      conditional: {
        field: 'primaryFocus',
        value: 'Other'
      }
    },
    currentChallenges: {
      label: 'What challenges is your client facing? (Optional)',
      type: 'textarea',
      placeholder: 'Share what your client is dealing with...'
    },
    emotionalPatterns: {
      label: 'What emotional pattern would your client like to shift?',
      type: 'radio',
      options: [
        'Suppressing emotions and "toughing it out"',
        'Anger or irritability masking deeper feelings',
        'Isolation and not asking for help',
        'Performance anxiety and pressure to succeed',
        'Difficulty being vulnerable or opening up',
        'Carrying everything alone without support',
        'Other'
      ]
    },
    emotionalPatternsOther: {
      label: 'Please specify the emotional pattern',
      type: 'text',
      placeholder: 'Describe the pattern your client wants to shift...',
      conditional: {
        field: 'emotionalPatterns',
        value: 'Other'
      }
    },
    empowermentGoal: {
      label: 'What does your client want to strengthen?',
      type: 'radio',
      options: [
        'Emotional vocabulary and expression',
        'Asking for help and accepting support',
        'Authentic masculinity - strong AND emotionally available',
        'Work-life boundaries and balance',
        'Confidence without dominance',
        'Purpose beyond achievement and productivity',
        'Other'
      ]
    },
    empowermentGoalOther: {
      label: 'Please specify what your client wants to strengthen',
      type: 'text',
      placeholder: 'Describe your client\'s empowerment goal...',
      conditional: {
        field: 'empowermentGoal',
        value: 'Other'
      }
    },
    emotionalTone: {
      label: 'What approach would work best for your client?',
      type: 'radio',
      options: [
        'Direct and honest - no BS, just truth',
        'Validating - acknowledging the pressure he faces',
        'Motivational - calling out his strength',
        'Grounding - creating space to breathe',
        'Empowering - redefining strength to include emotions',
        'Other'
      ]
    },
    emotionalToneOther: {
      label: 'Please specify the approach for your client',
      type: 'text',
      placeholder: 'Describe the approach that would work best for your client...',
      conditional: {
        field: 'emotionalTone',
        value: 'Other'
      }
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your client?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    }
  },
  groupTitle: 'Personalize Your Group Empowerment Session',
  groupQuestions: {
    groupContext: {
      label: 'What type of group empowerment session are you creating?',
      type: 'radio',
      options: [
        'Men\'s support or therapy group',
        'Father\'s group',
        'Veterans or first responders group',
        'Workplace or team leadership session',
        'Men\'s retreat or workshop',
        'Addiction recovery men\'s group',
        'Relationship skills group',
        'Other'
      ]
    },
    groupContextOther: {
      label: 'Please specify your group type',
      type: 'text',
      placeholder: 'Describe your group context...',
      conditional: {
        field: 'groupContext',
        value: 'Other'
      }
    },
    groupFocus: {
      label: 'What is your group\'s primary focus?',
      type: 'radio',
      options: [
        'Building emotional literacy and expression',
        'Supporting mental health and healing',
        'Fatherhood and family relationships',
        'Work-life balance and stress management',
        'Authentic masculinity and vulnerability',
        'Brotherhood and genuine connection',
        'Other'
      ]
    },
    groupFocusOther: {
      label: 'Please specify your group\'s focus',
      type: 'text',
      placeholder: 'Describe what your group focuses on...',
      conditional: {
        field: 'groupFocus',
        value: 'Other'
      }
    },
    groupDynamics: {
      label: 'How does your group engage best?',
      type: 'radio',
      options: [
        'Open discussion - breaking isolation',
        'Individual practice with group accountability',
        'Partner/buddy check-ins',
        'Silent group solidarity and presence',
        'Facilitated sharing with structured support',
        'Other'
      ]
    },
    groupDynamicsOther: {
      label: 'Please specify your group dynamics',
      type: 'text',
      placeholder: 'Describe how your group engages...',
      conditional: {
        field: 'groupDynamics',
        value: 'Other'
      }
    },
    sharedChallenges: {
      label: 'What challenges does your group face together? (Optional)',
      type: 'textarea',
      placeholder: 'Describe shared pressures, struggles, or patterns the group wants to address...'
    },
    groupStrengths: {
      label: 'What are your group\'s collective strengths?',
      type: 'radio',
      options: [
        'Mutual respect and non-judgment',
        'Shared commitment to emotional growth',
        'Willingness to be vulnerable',
        'Support and accountability',
        'Professional guidance available',
        'Other'
      ]
    },
    groupStrengthsOther: {
      label: 'Please specify your group\'s strengths',
      type: 'text',
      placeholder: 'Describe your group\'s collective strengths...',
      conditional: {
        field: 'groupStrengths',
        value: 'Other'
      }
    },
    additionalNotes: {
      label: 'Is there anything else the AI should know to create the perfect session for your group?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  },
  giftTitle: 'Personalize Empowerment Session for Your Loved One',
  giftQuestions: {
    primaryFocus: {
      label: 'What area of empowerment would help them most?',
      type: 'radio',
      options: [
        'Emotional expression and vulnerability',
        'Managing work stress and provider pressure',
        'Building healthy relationships and intimacy',
        'Mental health and depression/anxiety',
        'Setting boundaries and saying no',
        'Fatherhood and present parenting',
        'Other'
      ]
    },
    primaryFocusOther: {
      label: 'Please specify their focus area',
      type: 'text',
      placeholder: 'Describe what they need to focus on...',
      conditional: {
        field: 'primaryFocus',
        value: 'Other'
      }
    },
    currentChallenges: {
      label: 'What challenges are they facing? (Optional)',
      type: 'textarea',
      placeholder: 'Share what they\'re dealing with - this helps personalize the session...'
    },
    emotionalPatterns: {
      label: 'What emotional pattern would they benefit from shifting?',
      type: 'radio',
      options: [
        'Suppressing emotions and "toughing it out"',
        'Anger or irritability masking deeper feelings',
        'Isolation and not asking for help',
        'Performance anxiety and pressure to succeed',
        'Difficulty being vulnerable or opening up',
        'Carrying everything alone without support',
        'Other'
      ]
    },
    emotionalPatternsOther: {
      label: 'Please specify the emotional pattern',
      type: 'text',
      placeholder: 'Describe the pattern they want to shift...',
      conditional: {
        field: 'emotionalPatterns',
        value: 'Other'
      }
    },
    empowermentGoal: {
      label: 'What would you like this session to strengthen for them?',
      type: 'radio',
      options: [
        'Emotional vocabulary and expression',
        'Asking for help and accepting support',
        'Authentic masculinity - strong AND emotionally available',
        'Work-life boundaries and balance',
        'Confidence without dominance',
        'Purpose beyond achievement and productivity',
        'Other'
      ]
    },
    empowermentGoalOther: {
      label: 'Please specify what you want to strengthen for them',
      type: 'text',
      placeholder: 'Describe your empowerment goal for them...',
      conditional: {
        field: 'empowermentGoal',
        value: 'Other'
      }
    },
    additionalNotes: {
      label: 'Anything else the AI should know to create a perfect session for them?',
      type: 'textarea',
      placeholder: 'Any additional context, special requests, or details that would make this session more meaningful...'
    },
  }
};
